<template>
    <div>
        <ul class="menu-nav">
            <!--        Single menu looks like this-->
            <!--    v-slot="{ href, navigate, isActive, isExactActive }">-->

            <a href="https://core.terminalads.com/#/home" aria-haspopup="true" data-menu-toggle="hover"
               class="menu-item">
                <a :href="homeLink()" class="menu-link">
                    <!-- <span class="menu-text"> خانه </span> -->
                    <span class="menu-text"> <i class="fas fa-home fa-2x home-icon-color"></i></span>
                </a>
            </a>

            <router-link to="/dashboard" v-slot="{ href, navigate, isActive, isExactActive }">
                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]">
                    <a :href="href" class="menu-link" @click="navigate">
                        <span class="menu-text"> داشبورد </span>
                    </a>
                </li>
            </router-link>

            <!--        <div v-for="menu in menus">-->

            <li v-for="menu in menus.filter((x)=> x.name === 'ثبت سفارش' ||x.name==='تعرفه ها')"
                :key="menu.id"
                aria-haspopup="true"
                :data-menu-toggle="menu.parent_id === null ? 'hover' : 'click'" :class="[
          menu.parent_id === 0 ? 'menu-item ' : 'menu-item menu-item menu-item-submenu menu-item-open-dropdown',
          { 'menu-item-active': hasActiveChildren(menu.slug) }
        ]">


                <router-link v-if="!menu.children" :to="`/${menu.slug}`"
                             v-slot="{ href, navigate, isActive, isExactActive }">

                    <a :href="href" class="menu-link" @click="navigate">
                        <span class="menu-text"> {{ menu.name }} </span>
                    </a>
                </router-link>


                <span v-else class="menu-link menu-toggle noBackground">
          <span class="menu-text">{{ menu.name }}</span>
        </span>


                <div v-if="menu.children && menu.children.length > 0" class="menu-submenu menu-submenu-fixed">
                    <div class="menu-subnav megamenu" style="max-width: 1000px;">
                        <ul class="menu-content">
                            <li class="menu-item">
                                <h3 class="menu-heading menu-toggle">
                                    <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                    <span class="menu-text"> {{ menu.name }}</span>
                                    <i class="menu-arrow"></i>
                                </h3>
                                <!--                                        child or a slug is required to do so the following jobs -->
                                <ul class="menu-inner">


                                    <router-link v-for="child in menu.children" :key="child.id" :to="`/${child.slug}`"
                                                 v-slot="{ href, navigate, isActive, isExactActive }">
                                        <li aria-haspopup="true" class="menu-item" :class="[
                      isActive && 'menu-item-active',
                      isExactActive && 'menu-item-active'
                    ]">
                                            <a :href="href" class="menu-link" @click="navigate">
                                                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                                <span class="menu-text"> {{ child.name }} </span>
                                            </a>
                                        </li>
                                    </router-link>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
            <!--        </div>-->
            <!--        Parent child menu looks like this-->
        </ul>

    </div>

    <!--  <div>-->
    <!--    <ul class="menu-nav">-->

    <!--      <router-link to="/dashboard" v-slot="{ href, navigate, isActive, isExactActive }">-->
    <!--        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active',isExactActive && 'menu-item-active']"><a-->
    <!--            :href="href" class="menu-link"-->
    <!--            @click="navigate"><i-->
    <!--            class="menu-icon flaticon2-architecture-and-city"></i><span class="menu-text">صفحه نخست</span></a></li>-->
    <!--      </router-link>-->

    <!--      <router-link to="/singleSms" v-slot="{ href, navigate, isActive, isExactActive }">-->
    <!--        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[isActive && 'menu-item-active',isExactActive && 'menu-item-active']"><a-->
    <!--            :href="href" class="menu-link"-->
    <!--            @click="navigate"><i-->
    <!--            class="menu-icon  flaticon2-sms "></i><span class="menu-text">ارسال پیامک تکی</span></a></li>-->
    <!--      </router-link>-->


    <!--      <li aria-haspopup="true" v-for="menuTitle of menu"  data-menu-toggle="hover" class="menu-item" v-bind:class="{ 'menu-item-open': hasActiveChildren('/vue-bootstrap') }">-->
    <!--        <a href="#" class="menu-link menu-toggle" v-if="menuTitle.child.length>0">-->
    <!--          <i class="menu-icon flaticon2-digital-marketing"></i>-->
    <!--          <span class="menu-text">{{menuTitle.name}}</span>-->
    <!--          <i class="menu-arrow"></i>-->
    <!--        </a>-->
    <!--        <div class="menu-submenu" v-if="menuTitle.child.length>0">-->
    <!--          <span class="menu-arrow"></span>-->
    <!--          <ul class="menu-subnav"  v-for="subTitle of menuTitle.child">-->
    <!--            <router-link to="" v-slot="{ href, navigate, isActive, isExactActive }">-->
    <!--              <li-->
    <!--                  aria-haspopup="true"-->
    <!--                  data-menu-toggle="hover"-->
    <!--                  class="menu-item"-->
    <!--                  :class="[isActive && 'menu-item-active',isExactActive && 'menu-item-active']">-->
    <!--                <a :href="href" class="menu-link" @click="navigate">-->
    <!--                  <i class="menu-bullet menu-bullet-dot">-->
    <!--                    <span></span>-->
    <!--                  </i>-->
    <!--                  <span class="menu-text">{{subTitle.name}}</span>-->
    <!--                </a>-->
    <!--              </li>-->
    <!--            </router-link>-->
    <!--          </ul>-->
    <!--        </div>-->
    <!--      </li>-->
    <!--    </ul>-->
    <!--  </div>-->
</template>

<script>
export default {
    name: "KTMenu",
    data() {
        return {
            // menus: null,
            elsedo: {}
        }
    },
    mounted() {
        // this.getSpecialmenu();
    },
    computed: {
        menus() {
            return this.$store.getters['menu/items']
        }
    },
    methods: {
        homeLink() {
            return process.env.VUE_APP_HOME_URL;
        },
        hasActiveChildren(match) {
            return this.$route["path"].indexOf(match) !== -1;
        },
    }
};
</script>
<style scoped>
.noBackground {
    background: none !important;
}
</style>
<style>
.fa-home {
    color: #6cdb72;
}

body[data-scrolltop='on'] .home-icon-color {
    color: #6cdb72;
}
</style>
